import { Card, CardHeader, Stack, Button } from "@mui/material";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import MaterialButton from "../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from "../components/MaterialTypography";
import MaterialSelect from "../components/MasterSelect";
import { useState, useEffect } from "react";
import MaterialBox from "../components/MaterialBox";
import MaterialDataGrid from "../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import BASEURL from "../pages/Utils/Baseurl";
import axios from "axios";
import FileUpload from "../pages/Utils/FileUpload";
import DownloadIcon from "@mui/icons-material/Download";
import { FaCloudDownloadAlt } from "react-icons/fa";

const TechiInterviewTable = () => {
  const nav = useNavigate();

  const department = {
    value: "",
  };

  const handleclick = () => {
    nav("");
  };
  const [Department, SetDepartment] = useState([]);

  const [departmentdata, setdepartmentdata] = useState([]);
  const [Staffdata, setStaffdata] = useState([]);
  const [Status, setStatus] = useState({ value: "" });
  const [tabledata, settabledata] = useState([]);
  const [Sampledata, setSampledata] = useState([]);
 const [selectedDepartment, setSelectedDepartment] = useState({
    value: "All",
    label: "All",
  });
  const [jobid, setjobid] = useState();
 const [SelecteJobID,setSelecteJobID] = useState({value:'All',label:'All'})
  const [alljobid, setalljobid] = useState([]);

  const [feedbackid, setfeedbackid] = useState([]);

  useEffect(() => {
    fetchData();
    onDepartmentSubmit();
    OnStaffRequest();
    // Fetchfeedback();
  }, []);

  const downloadCV = async (cvFile) => {
    console.log("cvFile:", cvFile);

    let CvName = cvFile.split("/").pop();

    console.log("CvName:", CvName);

    const downloadButton = document.getElementById("downloadButton");
    if (downloadButton) downloadButton.style.display = "none";

    try {
      const fileUrl = `${FileUpload}${cvFile}`;
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      const fileUrlObject = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = fileUrlObject;
      link.download = CvName;
      link.click();

      URL.revokeObjectURL(fileUrlObject);
    } catch (error) {
      console.error("Error downloading the file:", error);
    } finally {
      if (downloadButton) downloadButton.style.display = "inline-block";
    }
  };

  const SalaryStructureListTable = {
    columns: [
      {
        field: "jobid",
        headerName: "Job ID",
        width: 130,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "candidateName",
        headerName: "Candidate Name",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "totalExperience",
        headerName: "Total Experience",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "expectedCtc",
        headerName: "Expected CTC",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "currentEmployer",
        headerName: "Current Emp",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "interviewAvailability",
        headerName: "Availability",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "hiringstatus",
        headerName: "Status",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      // {
      //   field: "Actions",
      //   headerName: "Actions",
      //   width: 130,
      //   editable: false,
      //   disableColumnMenu: true,
      //   sortable: true,
      // },
      {
        field: "map",
        headerName: "Download CV",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
    ],

    rows: tabledata.slice().reverse().map((data) => {
      const interviewDate = new Date(data.interviewAvailability);

      // Convert to Indian Standard Time
      const indianTime = new Date(
        interviewDate.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
      );

      const formattedDate = indianTime
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");

      return {
        id: data.id,
        jobid: data.jobid,
        candidateName: data.candidateName,
        totalExperience: data.totalExperience,
        expectedCtc: data.expectedCtc,
        currentEmployer: data.currentEmployer,
        allfeedback: data?.feedbackId,
        hiringstatus: data?.hiringstatus ? data?.hiringstatus : 'Pending',
        interviewAvailability: formattedDate, // Update formatted date
        map: (
          <>
            <FaCloudDownloadAlt
              onClick={(e) => {
                e.stopPropagation(); // Prevent the event from propagating
                downloadCV(data.cvFile); // Pass the file name or URL
              }}
              style={{ fontSize: "25px" }}
            >
              Download CV
            </FaCloudDownloadAlt>
          </>
        ),
      };
    }),
  };

  const handlechange = (event, setevent) => {
    console.log(setevent.name + "settev");

    if (setevent.name == "department") {
      const cloneddepartment = { ...Department };
      cloneddepartment.value = event;
      SetDepartment(cloneddepartment);
    } else if (setevent.name == "status") {
      const clonedstatus = { ...Status };
      clonedstatus.value = event;
      console.log(clonedstatus + "clonedstatus");
      setStatus(clonedstatus);
    } else {
      const clonedjobid = { ...jobid };
      clonedjobid.value = event;
      setjobid(clonedjobid);
    }
  };

  const departmentName = [
    {
      id: "HR",
      departmentName: "hr",
    },

    {
      id: "Dev",
      departmentName: "dev",
    },

    {
      id: "DEV",
      departmentName: "dev",
    },
  ];

  const [Departmentnames, setnames] = useState({
    depatmentdate: departmentName,
  });
  departmentName.forEach((data) => console.log(data));

  const onDepartmentSubmit = async () => {
    const query = `query {
        allDepartment {
            id
            departmentName
            departmentCode
        }
    }`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const departmentList = response.data.data.allDepartment;
      console.log("departmentList:", departmentList);

      setdepartmentdata(departmentList);
      // setallDepartment({
      //   ...allDepartment,
      //   departmentnames: departmentList,
      // });
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };

  const OnStaffRequest = async () => {
    const query = `query {
  allStaffRequests {
    id
    jobid
    requestDate
    teamName
    teamLeadName
    projectName
    startDate
    role
    salaryLpa
    experience
    employmentType
    approvalStatus
    jobStatus
    keySkills
    priority
    noOfPositions
    preference
    interviewPannel
    noOfRounds
    responsiblePerson
    positionStatus
    jd
    justificationForRequest
  }
}`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data.allStaffRequests;
      console.log("resultresult:", result);

    

      setStaffdata(result);
    } catch (error) {
      console.error("ResponseError:", error);
      // setPageState({ ...pageState, loading: false, error: true, message: error.message });
    }
  };

  const fetchData = async () => {
    const query = `query {
  allSourcingScreenings {
    id
    jobid
    candidateName
    screeningStatus
    source
    mobileNumber
    department
    emailid
    totalExperience
    relevantExperience
    currentCtc
    expectedCtc
    leadTime
    yearOfPassing
    currentEmployer
    location
    comments
    interviewAvailability
    interviewer
    cvFile
  }
}`;
    const query1 = `query GetAllTechnicalFeedback {
  allTechnicalFeedback {
    id
    comments
    hiringStatus
    professionalism
    technicalSkills
    communication
    sourcingScreening {
      id
      candidateName
    }
  }
}`;
    try {
      // setPageState({ ...pageState, loading: true });

      // const response = await axios.post(
      //   BASEURL,
      //   {
      //     query: query,
      //   },
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );

      const [response1, response2] = await Promise.all([
        axios.post(
          BASEURL,
          { query },
          { headers: { "Content-Type": "application/json" } }
        ),
        axios.post(
          BASEURL,
          { query: query1 },
          { headers: { "Content-Type": "application/json" } }
        ),
      ]);

      let result = response1.data.data.allSourcingScreenings;
      let result1 = response2.data.data.allTechnicalFeedback;
      console.log("resultget:", response1.data);
      console.log("resultget222:", response2.data);

      let filterdata = result.filter(
        (val) => val.screeningStatus === "Accepted"
      );

      let filterdata2 = filterdata.filter(
        (val) => val.screeningStatus == "Accepted"
      );
      console.log("filterdata:", filterdata2);

      setTimeout(() => {
        const updatedCandidateData = filterdata2.map((candidate) => {
          // Find the matching feedback item
          const matchingFeedback = result1.find(
            (feedback) => feedback.sourcingScreening.id === candidate.id
          );

          // Add the id from feedbackData if a match is found
          if (matchingFeedback) {
            return {
              ...candidate,
              feedbackId: matchingFeedback.id,
              hiringstatus: matchingFeedback.hiringStatus,
            };
          }
          return candidate; // Return unchanged candidate if no match
        });

        settabledata(updatedCandidateData);
        setSampledata(updatedCandidateData);

        let data = updatedCandidateData.map((value) => {
          return {
            value: value.jobid,
            label: value.jobid,
          };
        });
    
        setalljobid(data);
      }, 1000);

     
      // settabledata(filterdata)
    } catch (error) {
      console.error("ResponseError:", error);
      // setPageState({ ...pageState, loading: false, error: true, message: error.message });
    }
  };

  const Fetchfeedback = async () => {
    const query = `query GetAllTechnicalFeedback {
  allTechnicalFeedback {
    id
    comments
    hiringStatus
    professionalism
    technicalSkills
    communication
    sourcingScreening {
      id
      candidateName
    }
  }
}`;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response:", response.data.data.allTechnicalFeedback);

      let result = response.data.data.allTechnicalFeedback;
      setfeedbackid(result);
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const onRowClick = (e) => {
    console.log("Click:", e.row.allfeedback);

    if (e?.row?.allfeedback) {
      nav(`/technical/feedback?id=${e?.id}&dataid=${e?.row?.allfeedback}`);
    } else {
      nav(`/technical/feedback?id=${e?.id}`);
    }
  };

  const handledepartment = (selectedOption) => {
    
    let depname = selectedOption.label;
    setSelectedDepartment(selectedOption)
    let filterdata = Sampledata.filter((val)=> val.department == depname)

    if(depname == 'All'){
      settabledata(Sampledata)
    }else{
      settabledata(filterdata)
    }
    
  

    let filterdatass = Staffdata.filter((val) => val.teamName === depname);

    let alldata = filterdatass.filter(
      (val) => val.approvalStatus == "Approved" && val.jobStatus == "Open"
    );

    let data = alldata.map((value) => {
      return {
        value: value.jobid,
        label: value.jobid,
      };
    });

    setalljobid(data);
  };

  const handlejobid = (selectedOption) => {
    let idname = selectedOption.value;
    setjobid(idname);
    setSelecteJobID(selectedOption)
    console.log("Sampledata:", Sampledata);

    let filterdata = Sampledata.filter(
      (val) => val.jobid === idname && val.screeningStatus == "Accepted"
    );
    console.log("filterdata:", filterdata);

    const updatedCandidateData = filterdata.map((candidate) => {
    
      const matchingFeedback = feedbackid.find(
        (feedback) => feedback.sourcingScreening.id === candidate.id
      );

      // Add the id from feedbackData if a match is found
      if (matchingFeedback) {
        return {
          ...candidate,
          feedbackId: matchingFeedback.id,
          hiringstatus: matchingFeedback.hiringStatus,
        };
      }
      return candidate; // Return unchanged candidate if no match
    });

    // Output the result
    console.log("updatedCandidateData:", updatedCandidateData);

    // if(selectedDepartment.label !== 'All'){
    //    let 
    // }

    if(selectedDepartment.label !== 'All' && idname =='All'){

      let filterdata = Sampledata.filter(
        (val) => val.department === selectedDepartment.label && val.screeningStatus == "Accepted"
      );
      console.log("filterdata:", filterdata);
  
      const updatedCandidateData = filterdata.map((candidate) => {
      
        const matchingFeedback = feedbackid.find(
          (feedback) => feedback.sourcingScreening.id === candidate.id
        );
  
        // Add the id from feedbackData if a match is found
        if (matchingFeedback) {
          return {
            ...candidate,
            feedbackId: matchingFeedback.id,
            hiringstatus: matchingFeedback.hiringStatus,
          };
        }
        return candidate; // Return unchanged candidate if no match
      });

      console.log('updatedCandidateData:',updatedCandidateData);
      
      
   settabledata(updatedCandidateData)
   
   
    }else {
      settabledata(updatedCandidateData);
    }
  
  
  // if(selectedDepartment.label =='All'){
  //   if(idname == 'All'){
  //     settabledata(Sampledata)
  //   }else{
  //     let filterdata = Sampledata.filter((val)=> val.jobStatus == idname)
  //     console.log('filterdata:',filterdata);
  //     settabledata(filterdata)
  //   }
  
  // }else if (selectedDepartment.label !=='All'){
  //   if(idname == 'All'){
  //     let filterdata = Sampledata.filter((val)=>  val.teamName == selectedDepartment.label)
  //     settabledata(filterdata)
  //   }else{
  //     let filterdata = Sampledata.filter((val)=> val.jobStatus == idname && val.teamName == selectedDepartment.label)
  //     settabledata(filterdata)
  //   }
    
  
  // }
  }
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                margin={1}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Technical Interview
                  </MaterialTypography>
                  {/* <MaterialTypography variant="caption" color="text">
                                List of Employee Salary that you can get details of Employee Salary.
                            </MaterialTypography> */}
                </Stack>
              </Stack>

              <Stack direction="row" spacing={2}>
                <Stack>
                  <MaterialBox lineHeight={1} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      color="black"
                      fontWeight="bold"
                      lineHeight={3}
                    >
                      Department
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="department"
                    value={selectedDepartment}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handledepartment}
                    options={[
                      { value: "all", label: "All" }, // Manually adding the "All" option
                      ...departmentdata.map((value) => ({
                        value: value.id,
                        label: value.departmentName,
                      })),
                    ]}
                    error={false}
                    // success={true}
                  />
                </Stack>

                <Stack>
                  <MaterialBox lineHeight={1} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      color="black"
                      lineHeight={3}
                    >
                      Job Id
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="Jobid"
                    value={SelecteJobID}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handlejobid}
                    options = {[
                      { value: "All", label: "All" },
                      ...alljobid.map((value) => ({
                        value: value.value,
                        label: value.value,
                      })),
                    ]}
                  
                    error={false}
                    // success={true}
                  />
                </Stack>

                {/* <Stack>
                  <MaterialBox lineHeight={1} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      color="black"
                      fontWeight="bold"
                      lineHeight={3}
                    >
                      Status
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="status"
                    value={Status.value}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handlechange}
                    options={Departmentnames.depatmentdate.map((value) => {
                      console.log(value);
                      return {
                        value: value.id,
                        label: value.departmentName,
                      };
                    })}
                    error={false}
                    // success={true}
                    isClearable
                  />
                </Stack> */}

                <Stack alignItems="center" lineHeight={1}>
                  {/* <MaterialButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={handleclick}
                            
                        >
                            Source Profile
                        </MaterialButton> */}
                </Stack>
              </Stack>
            </>
          }
        />
        <MaterialDataGrid
          // customHeight={550}
          rows={SalaryStructureListTable.rows}
          columns={SalaryStructureListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onRowClick}
          loading={""}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No technical interview found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any technical interview details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};
export default TechiInterviewTable;
